import { render } from "./UserTable.vue?vue&type=template&id=80ec48b0"
import script from "./UserTable.vue?vue&type=script&lang=js"
export * from "./UserTable.vue?vue&type=script&lang=js"
script.render = render

export default script